module.exports = __webpack_public_path__ + "static/media/Goodnest_android_3.0f0030db.jpg";